import angular from 'angular';
import { studioServices } from './services';
import { studioComponents } from './components';
export const studioModule = angular
    .module('studioModule', [studioServices, studioComponents])
    .name;
